import React from 'react';
import { Navigate } from 'react-router-dom'
function PrivateRoute({ isAuthenticated, children }) {
  if (isAuthenticated) {
    return children;
  }
  return <Navigate to="/" replace />;
}
export default PrivateRoute